import React, { memo } from 'react';
import { NodeBox } from '../../components/NodeBox';
import { ResourceName } from '../../components/ResourceName';
import { ReactComponent as ErrorIcon } from 'new/components/icons/fi-rr-warning.svg';
import styles from './Error.module.scss';

interface ErrorProps {
  data: any;
}

export const Error = memo((props: ErrorProps) => {
  const { data } = props;

  return (
    <NodeBox data={data} className={styles.container} variant="iconOnly" icon={<ErrorIcon />}>
      <ResourceName {...props} isCollapsed={true}>
        ERROR
      </ResourceName>
    </NodeBox>
  );
});
